package kz.dentalcrm.app.screens.login.mvi

data class LoginViewState(
    val isLoading: Boolean = false,
    val error: String? = null,
)
